import script from "./LoadingView.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingView.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"LoadingView.vue"]])

export default __exports__